import CurrencySelector from '@/app/components/CurrencySelector'
import LanguageAndCurrencySelect from '@/app/components/LanguageAndCurrencyMobile'
import { Icons } from '@/app/components/ui/Icons'
import classNames from 'classnames'
import { pick } from 'lodash'
import { NextIntlClientProvider, useMessages } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

export interface Props {
	lang: string
	isMain?: boolean
	isSticky?: boolean
	children?: {
		middle?: React.ReactNode
		bottom?: React.ReactNode
	}
}

const Top: FC<Props> = (props) => {
	const { lang, isMain = false, children, isSticky } = props
	const messages = pick(useMessages(), ['Keywords', 'Header'])

	return (
		<div
			className={classNames('max-md:bg-white container', {
				'py-3.5 md:py-6 max-lg:rounded-4xl': !isMain,
				'max-lg:py-5 md:max-lg:px-8': isMain,
			})}
		>
			<div className={classNames('flex justify-between items-center h-[52px]',
				{
					'max-md:h-10': isMain
				})}>
				<Link
					href={`/${lang}`}
					aria-label="Main Logo Link"
					className={'md:hidden'}
				>
					<Icons.logoSmall className={classNames({ hidden: !isMain })} />
					<Icons.logoSmaller className={classNames({ hidden: isMain })} />
				</Link>
				<div className="hidden md:block w-[234px] h-full">
					<Link
						href={`/${lang}`}
						aria-label="Main Logo Link"
						className="inline-block h-full"
					>
						<Icons.logoSmall className="md:hidden" />
						{isMain ? (
							<>
								<Image
									src={'/images/logo.png'}
									width={106}
									height={52}
									alt="TopHotelPrices Logo"
									unoptimized
								/>
							</>
						) : (
							<Image
								src={'/images/logo-colored.png'}
								width={106}
								height={52}
								alt="TopHotelPrices Logo"
								unoptimized
							/>
						)}
					</Link>
				</div>
				{children?.middle}
				<NextIntlClientProvider locale={'en'} messages={messages}>
					<div className="md:hidden">
						<LanguageAndCurrencySelect />
					</div>
					<div className="hidden md:flex w-[234px] justify-end">
						{/* <LanguageSelector
							isMainPage={isMain}
							isSticky={isSticky as boolean}
						/> */}
						<CurrencySelector
							isMainPage={isMain}
							isSticky={isSticky as boolean}
						/>
					</div>
				</NextIntlClientProvider>
			</div>
			{children?.bottom}
		</div>
	)
}

export default Top
